import React from 'react'
import { getProductTag } from '@helpers/products'
import { PRODUCT_COLOUR_TAGS } from '@consts/index'
import Badge from '@components/ui/Badge'
import colours from './colours.module.scss'
import styles from './styles.module.scss'

type ColorInfoProps = {
  customTag?: string
  productColor: string
  productTags: string[]
}

export const ColorInfoTag = ({
  productTags,
  customTag
}: Omit<ColorInfoProps, 'productColor'>) => {
  const tag = getProductTag(productTags, PRODUCT_COLOUR_TAGS) || ''
  const badgeColor = /Low/.test(tag) ? colours.color1 : colours.color2
  return customTag || tag ? (
    <div className={styles.productForm__colorBadge}>
      {' '}
      <Badge
        medium
        badgeType="minimal"
        themeColour={badgeColor}
        title={customTag || tag}
      />
    </div>
  ) : null
}

const ColorInfo = ({
  productColor,
  productTags,
  customTag
}: ColorInfoProps) => (
  <h2 className={styles.productForm__color}>
    {productColor}
    <ColorInfoTag productTags={productTags} customTag={customTag} />
  </h2>
)

export default ColorInfo
